module.exports = __webpack_public_path__ + "static/media/ieee_tunisia_black.2764455a.png";